import { useNavigate } from "react-router-dom";
import { Card, CardContent } from "@/components/ui/card";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import DriverManagement from "./DriverManagement";
import VehicleManagement from "../VehicleManagement";
import EditVehicle from "../EditVehicle";
import StudentVehicleMapping from "./StudentVehicleMapping";
import FuelManagement from "../FuelManagement/FuelManagement";
import { useState, useEffect } from "react";

const BusContent = () => {
  const navigate = useNavigate();
  const [editingVehicleId, setEditingVehicleId] = useState(null);
  const [activeTab, setActiveTab] = useState(() => {
    return localStorage.getItem("busActiveTab") || "vehicles";
  });

  useEffect(() => {
    if (activeTab === "tracking") {
      navigate("/dashboard/live-tracking");
    }
  }, [activeTab, navigate]);

  // Update localStorage when tab changes
  useEffect(() => {
    localStorage.setItem("busActiveTab", activeTab);
  }, [activeTab]);

  return (
    <div className="space-y-6">
      <Tabs value={activeTab} onValueChange={setActiveTab} className="w-full">
        <TabsList className="mb-6 grid grid-cols-5 md:grid-cols-5 gap-2 bg-white p-1">
        <TabsTrigger
            value="tracking"
            className="rounded-md data-[state=active]:bg-[#0263cc] data-[state=active]:text-white"
          >
            Live Tracking
          </TabsTrigger>
          <TabsTrigger
            value="vehicles"
            className="rounded-md data-[state=active]:bg-[#0263cc] data-[state=active]:text-white"
          >
            Vehicle Management
          </TabsTrigger>
        
          <TabsTrigger
            value="students"
            className="rounded-md data-[state=active]:bg-[#0263cc] data-[state=active]:text-white"
          >
            Student Mapping
          </TabsTrigger>
          <TabsTrigger
            value="drivers"
            className="rounded-md data-[state=active]:bg-[#0263cc] data-[state=active]:text-white"
          >
            Drivers
          </TabsTrigger>
          <TabsTrigger
            value="fuel"
            className="rounded-md data-[state=active]:bg-[#0263cc] data-[state=active]:text-white"
          >
            Fuel Management
          </TabsTrigger>
        </TabsList>

        <TabsContent value="vehicles" className="space-y-6">
          {editingVehicleId ? (
            <EditVehicle vehicleId={editingVehicleId} onBack={() => setEditingVehicleId(null)} />
          ) : (
            <VehicleManagement onEditVehicle={id => setEditingVehicleId(id)} />
          )}
        </TabsContent>

        <TabsContent value="tracking" className="hidden" />

        <TabsContent value="drivers">
          <Card>
            <CardContent className="p-6">
              <div className="mb-6">
                <h3 className="text-lg font-semibold">Transport Staff</h3>
                <p className="text-sm text-muted-foreground">
                  List of all bus and van drivers
                </p>
              </div>
              <DriverManagement />
            </CardContent>
          </Card>
        </TabsContent>

        <TabsContent value="fuel">
          <FuelManagement />
        </TabsContent>

        <TabsContent value="students">
          <StudentVehicleMapping />
        </TabsContent>
      </Tabs>
    </div>
  );
};

export default BusContent;
